import styled from 'styled-components'

export const MasterContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`
